import { Terminal } from '@/models/terminal';
import { Avatar, Card, Col, Empty, List, Row, TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';
import './index.scss';


interface TerminalDetailProps {
  terminal?: Terminal;
}

function AppFirmware(props: TerminalDetailProps) {
  const { t } = useTranslation();

  const data = [
    {
      title: 'PayDroid_8.1.4_Sagittarius_V11.1.65_20240813',
    },
    {
      title: 'PayDroid_8.1.3_Sagittarius_V11.1.65_20240813',
    },
    {
      title: 'PayDroid_8.1.2_Sagittarius_V11.1.65_20240813',
    },
    {
      title: 'PayDroid_8.1.1_Sagittarius_V11.1.65_20240813',
    },
    {
      title: 'PayDroid_8.1.0_Sagittarius_V11.1.65_20240813',
    },
  ];

  return (
    <Row gutter={24}>
      <Col span={24}>
        <Card
          style={{ marginTop: 16 }}
          title="Installed Firmware"
        >
          <Row>
            <Col span={24}>
              <List
                itemLayout="horizontal"
                dataSource={data}
                renderItem={(item, index) => (
                  <List.Item>
                    <List.Item.Meta
                      avatar={<Avatar src={`https://api.dicebear.com/8.x/icons/svg?seed=3`} />}
                      title={<a>{item.title}</a>}
                      description={`Base Version: ${item.title} File Size: 27${index}.3 MB`}
                    />
                  </List.Item>
                )}
              />
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
}
export default AppFirmware;
